import QuestTrackerProgressPopup from "./QuestTrackerProgressPopup";
import QuestTrackerDefaultPopup from "./QuestTrackerDefaultPopup";
import QuestTrackerPopup from "./QuestTrackerPopup";
import {texture} from "p3";

export default class QuestTracker extends PIXI.Container {
    constructor() {
        super();

        this._queue = [];
        this._activePopup = null;
        this._activePopupTime = -1;
        this._activePopupDuration = 4;

        this.init();
    }

    init() {
    }

    update() {
        if (this._activePopup && this._activePopupTime > -1) {
            this._activePopupTime += window.dt;
            if (this._activePopupTime > this._activePopupDuration) {
                this._removePopup().then(() => {
                    this._nextPopup().then();
                });
            }
            this._activePopup.update();
        }
    }

    /**
     * @param {Quest} quest
     * @return {boolean}
     */
    trackQuestAssign(quest) {
        return this._addQuestPopup(new QuestTrackerDefaultPopup(QuestTrackerPopup.TYPE_ASSIGN, quest, "", texture("icon_npc_quest_in_progress")));
    }

    /**
     * @param {Quest} quest
     * @return {boolean}
     */
    trackQuestComplete(quest) {
        return this._addQuestPopup(new QuestTrackerDefaultPopup(QuestTrackerPopup.TYPE_COMPLETE, quest, "", texture("icon_npc_quest_complete"), 0.7));
    }

    /**
     * @param {Quest} quest
     * @return {boolean}
     */
    trackQuestProgress(quest) {
        const popup = this._getPopup(QuestTrackerPopup.TYPE_PROGRESS, quest);
        if (popup && quest.value <= quest.target) {
            popup.setProgress(quest.progress, true);
            this._activePopupTime = 0;
        } else {
            return this._addQuestPopup(new QuestTrackerProgressPopup(quest));
        }
        return false;
    }

    /**
     * @param {QuestTrackerPopup} popup
     * @return {boolean}
     * @private
     */
    _addQuestPopup(popup) {
        if (!this._isPopupQueued(popup.type, popup.quest)) {
            popup.init();
            this._queue.push(popup);
            this._nextPopup().then();
            return true;
        }
        return false;
    }

    /**
     * @param {string} type
     * @param {Quest} quest
     * @return {QuestTrackerPopup}
     * @private
     */
    _getPopup(type, quest) {
        return this._queue.filter(x => x.type === type && x.quest === quest)[0];
    }

    /**
     * @param {string} type
     * @param {Quest} quest
     * @return {boolean}
     * @private
     */
    _isPopupQueued(type, quest) {
        return !!this._getPopup(type, quest);
    }

    /**
     * @return {Promise}
     * @private
     */
    _nextPopup() {
        return new Promise((resolve) => {
            if (!this._activePopup && this._queue.length >= 1) {
                this._activePopup = this._queue[0];
                this.addChild(this._activePopup);

                this._activePopup.animateIn().then(() => {
                    this._activePopupTime = 0;
                    resolve();
                });
            } else {
                resolve();
            }
        });
    }

    /**
     * @return {Promise}
     * @private
     */
    _removePopup() {
        this._activePopupTime = -1;
        return new Promise((resolve) => {
            if (this._activePopup) {
                this._activePopup.animateOut().then(() => {
                    this.removeChild(this._activePopup);
                    this._activePopup = null;
                    this._queue.shift();
                    resolve();
                });
            } else {
                resolve();
            }
        });
    }
}